import { Api } from 'common/utils/api';
import { useMutation } from 'react-query';

interface Input {
    patientGivenName: string;
    patientFamilyName: string;
    patientDob: Date;
    facilityId: number;
}

interface Response {
    patientFullName: string;
    patientEpicId: string;
    patientDob: string;
}

export function usePatientSearch() {
    const search = useMutation((input: Input) => Api.post<Response[]>({ path: 'epic/patient-search', body: input }));

    return {
        search: search.mutateAsync,
    };
}
